
import { useRef, useCallback } from 'react';

export const useAudioPlayer = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const cleanupAudio = useCallback(() => {
    console.log('Starting audio cleanup...');
    if (audioRef.current) {
      try {
        audioRef.current.pause();
        audioRef.current = null;
      } catch (error) {
        console.error('Error during audio cleanup:', error);
      }
    }
    console.log('Audio cleanup completed');
  }, []);

  const playAudio = async (audioData: ArrayBuffer): Promise<void> => {
    try {
      const blob = new Blob([audioData], { type: 'audio/mpeg' });
      const audio = new Audio();
      audio.src = URL.createObjectURL(blob);
      
      await new Promise((resolve, reject) => {
        audio.oncanplaythrough = resolve;
        audio.onerror = reject;
        audio.load();
      });

      audioRef.current = audio;
      
      // Set up onended handler before playing
      const playbackPromise = new Promise<void>((resolve) => {
        audio.onended = () => {
          console.log('Audio playback ended');
          URL.revokeObjectURL(audio.src);
          resolve();
        };
      });

      console.log('Starting audio playback');
      await audio.play();
      
      return playbackPromise;
    } catch (error) {
      console.error('Error playing audio:', error);
      throw error;
    }
  };

  return {
    audioRef,
    cleanupAudio,
    playAudio
  };
};
